<template>
  <ul class="c-bid-batch">
    <li><a href="javascript:;" @click="$emit('on-click')">广告出价</a></li>
    <template>
      <li v-if="bidType === 'CUSTOM'">
        目标出价:
        <span>{{ cpaBid }}</span
        >，
        <!-- <span v-else>{{bid}}</span> -->
      </li>
      <li>
        深度出价:
        <span v-if="deep" v-html="deep"></span>
        <!-- <span v-else-if="deepCpabidRange">随机</span> -->
        <span v-else>{{ deepCpabid }}</span>
      </li>
      <li v-if="roi && bidType === 'CUSTOM'">
        ，ROI系数:
        <span>{{ roiGoal }}</span>
      </li>
    </template>
  </ul>
</template>
<script>
export default {
  name: 'bidBatch',
  props: {
    smartBidType: {
      type: String
    },
    adjustCpa: {
      type: Number
    },
    deepBidType: {
      type: String
    },
    bidRange: {
      type: Number
    },
    deepCpabidRange: {
      type: Number
    },
    deepCpabid: {
      type: [Number, String]
    },
    roiGoal: {
      type: [Number, String]
    },
    pricing: {
      type: String
    },
    bid: {
      type: [Number, String]
    },
    cpaBid: {
      type: [Number, String]
    },
    bidType: {
      type: String
    }
  },
  computed: {
    roi() {
      return this.deepBidType === 'ROI_COEFFICIENT'
    },
    deep() {
      if (this.deepBidType === '') return '无'
      else if (this.deepBidType === 'ROI_COEFFICIENT') return 'ROI系数'
      else if (this.deepBidType === 'BID_PER_ACTION') return '每次付费出价'
      else if (this.deepBidType === 'DEEP_BID_MIN') return '自定义双出价'
      else return ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-bid-batch {
  display: inline-block;
  margin: 0;

  li {
    display: inline;
  }
}
</style>
